<template>
    <div>
        <el-row type="flex" class="adresserow">
            <el-form
                v-if="modifmanuelle"
                ref="adresseForm"
                :model="activeAdresse"
                :rules="rules"
                label-position="left"
                label-width="150px"
                style="max-width: 500px;"
            >
                <el-form-item
                    label="Numéro"
                    prop="housenumber"
                    :error="getErrorForField('housenumber', errors)"
                >
                    <el-input
                        v-model="activeAdresse.housenumber"
                        placeholder="ex: 11 bis"
                    />
                </el-form-item>
                <el-form-item
                    label="Voie*"
                    prop="street"
                    :error="getErrorForField('street', errors)"
                >
                    <el-input
                        v-model="activeAdresse.street"
                        type="text"
                        placeholder="ex: Rue traversière"
                    />
                </el-form-item>
                <el-form-item
                    label="Complément"
                    prop="complement"
                    :error="getErrorForField('complement', errors)"
                >
                    <el-input
                        v-model="activeAdresse.complement"
                        placeholder="ex: 2ème étage"
                    />
                </el-form-item>
                <el-form-item
                    label="Code postal*"
                    prop="postcode"
                    :error="getErrorForField('postcode', errors)"
                >
                    <el-input
                        v-model="activeAdresse.postcode"
                        placeholder="ex: 75012"
                    />
                </el-form-item>
                <el-form-item
                    label="Ville*"
                    prop="city"
                    :error="getErrorForField('city', errors)"
                >
                    <el-input
                        v-model="activeAdresse.city"
                        placeholder="ex: PARIS"
                    />
                </el-form-item>
                <el-form-item label="Pays*" prop="pays">
                    <el-input :disabled="true" value="FRANCE" />
                </el-form-item>
                <el-form-item>
                    <el-button @click="restart">
                        Nouvelle adresse
                    </el-button>
                    <el-button
                        type="success"
                        :disabled="!cansave"
                        @click="handleSaveAdresse"
                        v-html="noserver ? 'Valider' : 'Enregistrer'"
                    />
                </el-form-item>
            </el-form>
            <template v-else>
                <el-input
                    v-if="!founded"
                    v-model="apisearch"
                    prefix-icon="el-icon-search"
                    clearable
                    placeholder="ex : 11 bis rue Traversière Paris"
                    @input="handleType"
                />
                <template v-else>
                    <div class="adresseline">
                        <div>
                            {{ activeAdresse.housenumber }}
                            {{ activeAdresse.street }}
                        </div>
                        <div v-if="activeAdresse.complement">
                            {{ activeAdresse.complement }}
                        </div>
                        <div>
                            {{ activeAdresse.postcode }}
                            {{ activeAdresse.city }}
                        </div>
                    </div>
                    <el-button
                        type="success"
                        class="button"
                        @click="modifmanuelle = !modifmanuelle"
                    >
                        modifier
                    </el-button>
                </template>
            </template>
        </el-row>
        <ul v-if="apisearch" v-loading="searching" class="listadd">
            <li v-for="(feature, index) in features" :key="'feature' + index">
                {{ feature.properties.label }}
                <el-button
                    size="mini"
                    type="success"
                    icon="el-icon-plus"
                    @click="handleSelectFeature(index)"
                />
            </li>
            <li>
                <el-link type="success" @click="modifmanuelle = true">
                    je ne trouve pas mon adresse, je saisie les champs
                    manuellement.
                </el-link>
            </li>
        </ul>
    </div>
</template>

<script>
import Resource from "@/api/resource";
const adresseResource = new Resource("adresses");
import AdressesGouv from "@/api/adressesgouv";
const adressesGouvResource = new AdressesGouv();
import Inscription from "@/api/inscription";
const inscriptionResource = new Inscription();

export default {
    name: "Adresses",
    props: {
        adresse_id: {
            type: Number,
            default: 0
        },
        editAdresse: {
            type: Object,
            default: () => {
                return {};
            }
        },
        column_adresse: {
            type: String,
            default: ""
        },
        prop: {
            type: String,
            default: "adresse_showlabel"
        },
        noserver: {
            type: Boolean,
            default: false
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            activeAdresse: {},
            loading: false,
            /*
            rules: {},
            */
            rules: {
                housenumber: {},
                street: {},
                complement: {},
                postcode: {},
                city: {}
            },
            errors: [],
            apisearch: "",
            features: [],
            modifmanuelle: false,
            originalApiId: "",
            nouvelleAdresse: false,
            searching: false,
            founded: false
        };
    },
    mounted() {
        this.resetActiveAdresse();
    },
    watch: {
        modifmanuelle(val) {
            if (val) {
                this.parent.cantsave = true;
                this.apisearch = "";
            } else {
                this.parent.cantsave = false;
            }
        }
    },
    computed: {
        cansave() {
            if (this.modifmanuelle || this.nouvelleAdresse) {
                return true;
            }
            return false;
        },
        messageManuelle() {
            if (!this.activeAdresse.apigouv_id && this.nouvelleAdresse) {
                return "Ajout manuel";
            }
            return "Modification manuelle";
        }
    },
    methods: {
        resetActiveAdresse() {
            this.activeAdresse = {
                apigouv_id: "",
                city: "",
                citycode: "",
                context: "",
                id: "",
                importance: "",
                label: "",
                lat: "",
                lon: "",
                name: "",
                postcode: "",
                score: "",
                type: "",
                x: "",
                y: "",
                street: "",
                housenumber: ""
            };
        },
        restart() {
            this.apisearch = "";
            this.modifmanuelle = false;
            this.founded = false;
            this.resetActiveAdresse();
            this.parent.callbackAdresse(false, this.prop, this.column_adresse);
        },
        handleNouvelleAdresse() {
            this.resetActiveAdresse();
            this.nouvelleAdresse = true;
        },
        async getAdresse() {
            this.loading = true;
            const { data } = await adresseResource.get(this.adresse_id);
            this.activeAdresse = data;
            this.original_apigouv_id = data.apigouv_id;
            this.loading = false;
        },
        handleSaveAdresse() {
            this.errors = [];
            this.loading = true;
            if (this.noserver) {
                //test que champs OK
                inscriptionResource
                    .testadresse(this.activeAdresse)
                    .then(response => {
                        console.log(response);
                        this.$message({
                            message: "Adresse correcte",
                            type: "success",
                            duration: 2 * 1000
                        });
                        this.parent.callbackAdresse(
                            this.activeAdresse,
                            this.prop,
                            this.column_adresse
                        );
                        this.loading = false;
                        this.founded = true;
                        this.modifmanuelle = false;
                    })
                    .catch(error => {
                        console.log("error");
                        console.log(error.response);
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        this.updating = false;
                        this.$message({
                            message: "Erreur dans les champs",
                            type: "error",
                            duration: 2 * 1000
                        });
                        this.loading = false;
                        this.founded = true;
                        this.modifmanuelle = true;
                    });
                return true;
            }
            if (this.nouvelleAdresse) {
                adresseResource
                    .store(this.activeAdresse)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.$message({
                            message: "Adresse ajoutée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        this.parent.callbackAdresse(
                            response.data.id,
                            response.data.label,
                            this.column_adresse
                        );
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                adresseResource
                    .update(this.adresse_id, this.activeAdresse)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.parent.callbackAdresse(
                            response.data.id,
                            response.data.label,
                            this.column_adresse
                        );
                        this.$message({
                            message: "Adresse mise à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        },
        handleType() {
            this.searching = true;
            if (this.apisearch.length > 3) {
                adressesGouvResource
                    .search({ q: this.apisearch })
                    .then(response => {
                        // console.log("response");
                        // console.log(response);
                        if (response.data) {
                            this.features = response.data.features;
                        }
                        this.searching = false;
                    })
                    .catch(error => {
                        console.log("error");
                        console.log(error.response);
                        this.$message({
                            message: "Erreur de api.gouv",
                            type: "error",
                            duration: 5 * 1000
                        });
                        this.searching = false;
                    });
            } else {
                this.features = [];
                this.searching = false;
            }
        },
        handleSelectFeature(index) {
            this.apisearch = "";
            // this.activeAdresse = this.features[index].properties;
            Object.assign(this.activeAdresse, this.features[index].properties);
            this.activeAdresse.apigouv_id = this.activeAdresse.id;
            this.activeAdresse.id = null;
            if (
                this.features[index].geometry &&
                this.features[index].geometry.coordinates
            ) {
                this.activeAdresse.lat = this.features[
                    index
                ].geometry.coordinates[1];
                this.activeAdresse.lon = this.features[
                    index
                ].geometry.coordinates[0];
            }
            if (!this.features[index].properties.street) {
                this.activeAdresse.street = this.features[
                    index
                ].properties.name;
            }
            this.handleSaveAdresse();
        }
    }
};
</script>
